import React from "react";

const TextInput = ({
  id,
  inputType,
  inputChange,
  value,
  label,
  icon,
  error,
  ...others
}) => {
  const { isDisabled, isRequiredMark } = others;
  return (
    <div className="pr mat-form-field-wrapper inp-50">
      <div className="mat-form-field-flex">
        <div className="mat-form-field-infix">
          <input
            className="mat-input-element user-input pac-target-input"
            id={id}
            name={id}
            type={inputType}
            onChange={inputChange}
            value={value}
            disabled={isDisabled ? "disabled" : ""}
          />
          <span
            className={`mat-form-field-label-wrapper left-36 ${
              value !== "" ? "not-empty" : ""
            }`}
          >
            <label
              className={`mat-form-field-label ${error ? "error" : ""}`}
              id={`${id}-label`}
              htmlFor={id}
            >
              {label}{" "}
              <span className="is-required">{isRequiredMark ? "*" : ""}</span>
            </label>
          </span>
          <i className={`fa ${icon} user-icon`}></i>
        </div>
      </div>
      <div className={`mat-form-field-underline ${error ? "error" : ""}`}></div>
    </div>
  );
};

export default TextInput;
